<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>

    <button mat-flat-button color="accent" (click)="save()" [disabled]="save_disabled">Guardar configuración</button>
  </div>

  @for (ssr of settings; track ssr) {
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <h2>{{ ssr.section | bisualSettingSectionKeyToTitle }}</h2>
        </div>
      </div>
      <div class="container">
        <div class="row">
          @for (set of ssr.settings; track set) {
            <div class="col-12 col-lg-6">
              <label [for]="set.setting.key">{{ set.setting.name }}</label>
              <p class="setting-description">{{ set.setting.description }}</p>
              @switch (set.setting.type) {
                @case ('boolean') {
                  <mat-slide-toggle
                    [id]="set.setting.key"
                    [checked]="isBooleanSettingEnabled(set.setting.value)"
                    (change)="onBooleanChange($event.checked, set)"
                  >
                    {{ isBooleanSettingEnabled(set.setting.value) ? 'Activo' : 'Inactivo' }}
                  </mat-slide-toggle>
                }
                @case ('email') {
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      type="email"
                      [ngModel]="set.setting.value"
                      (ngModelChange)="onInputChange($event, set)"
                      [name]="set.setting.key"
                      [id]="set.setting.key"
                    />
                  </mat-form-field>
                }
                @case ('number') {
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      type="number"
                      [ngModel]="set.setting.value"
                      (ngModelChange)="onInputChange($event, set)"
                      [name]="set.setting.key"
                      [id]="set.setting.key"
                    />
                  </mat-form-field>
                }
                @default {
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      type="text"
                      [ngModel]="set.setting.value"
                      (ngModelChange)="onInputChange($event, set)"
                      [name]="set.setting.key"
                      [id]="set.setting.key"
                    />
                    @if (set.setting.regex_pattern_id !== null) {
                      <mat-hint align="end">Regex: {{ set.setting.regex_pattern_id }}</mat-hint>
                    }
                  </mat-form-field>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
